import firebase from '../firebase-config'
import firebaseroot from 'firebase'
import axios from 'axios'

var acuerdoRef = firebase.db.ref('acuerdos')
var objetivosAcuerdoRef = firebase.db.ref('objetivosAcuerdo')

var instance = axios.create({
  baseURL: process.env.baseURL,
  headers: {'Content-Type': 'application/json'}
})

export default {
  getAll () {
    return acuerdoRef
  },
  getById (acuerdoId) {
    let config = {
      url: '/acuerdo/' + acuerdoId,
      method: 'get'
    }
    return instance.request(config)
    // return acuerdoRef.child(acuerdoId)
  },
  getByEmailEditor (editorEmail) {
    // return acuerdoRef.startAt(editorEmail).endAt(editorEmail) // .orderByChild('finalizado')
    return acuerdoRef.orderByChild('editor').equalTo(editorEmail)
  },
  getByEmailOwner (ownerEmail) {
    return acuerdoRef.orderByChild('owner').equalTo(ownerEmail)
  },
  getObjetivosByAcuerdo (acuerdoId) {
    return objetivosAcuerdoRef.child(acuerdoId)
  },
  createAcuerdo (editor, owner) {
    let config = {
      url: '/createAcuerdo',
      method: 'post',
      data: {
        editor: editor,
        owner: owner
      }
    }
    return instance.request(config)
  },
  guardar (acuerdoId, objetivos) {
    objetivos.forEach((obj) => {
      delete obj['.key']
    })
    return objetivosAcuerdoRef.child(acuerdoId).set(objetivos)
  },
  enviar (acuerdoId, objetivos) {
    objetivos.forEach((obj) => {
      delete obj['.key']
    })
    let updateObject = {}
    updateObject['acuerdos/' + acuerdoId + '/sent'] = firebaseroot.database.ServerValue.TIMESTAMP
    updateObject['objetivosAcuerdo/' + acuerdoId] = objetivos
    return firebase.db.ref().update(updateObject)
  },
  finalizar (acuerdoId, objetivos) {
    objetivos.forEach((obj) => {
      delete obj['.key']
    })
    let updateObject = {}
    updateObject['acuerdos/' + acuerdoId + '/finalizado'] = firebaseroot.database.ServerValue.TIMESTAMP
    updateObject['objetivosAcuerdo/' + acuerdoId] = objetivos
    return firebase.db.ref().update(updateObject)
  }
}



// WEBPACK FOOTER //
// ./src/services/objetivos.js